require('../bootstrap');
require('../components/translate');

require('dropzone/dist/dropzone-min');
require('../components/social-share');
require('../components/google-map');
require('../components/ecommerce');
require('../components/pagination');
require('../components/modal');
require('../components/gallery-block');
require('../components/copy-ticket-information');
require('humanize-duration/humanize-duration');
require('../components/bootstrap-dropdown');
require('../components/form-enter-submit');
require('../components/social-share');
require('../components/prevent-input');
require('../components/btn-modal');
require('masonry-layout');
import {initializeCopyTicketInformation} from "../components/copy-ticket-information";
import {initializeCountryRegionSelector} from "../components/crs";
import {initializeDateTimePicker} from '../components/daterangepicker';
import {initializePaymentContainer} from '../components/ecommerce';
import {initializePagination} from "../components/pagination";
import {initializeTextEditor} from '../components/texteditor';
import {initializeSocialButtonShare} from '../components/social-share';
import {initializePaymentForm} from "../components/payment-form";
import {initializeGalleryBlock} from "../components/gallery-block";
import {initializePaymentTypeSelector} from '../components/payment-type-selector';
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import Load from "../components/load";
import Masonry from "masonry-layout";

window.initializeGalleryBlock = initializeGalleryBlock;
window.Load = Load;
window.MarkerClusterer = MarkerClusterer;
window.humanizeDuration = require('humanize-duration');
import TemplateEngine from './template';

$(document).ready(function () {
    window.is_modal_request = false;
    initializePlugins();

    $('[data-masonry-layout="true"]').each(function () {
        let self = this;
        var msnry = new Masonry(self, {
            percentPosition: true,
        });
    });
});


$(window).on('unload', function () {
    initializePlugins();
    new Load(false);
});

window.initializePlugins = initializePlugins;

/**
 * Initialize plugins
 */
function initializePlugins(reset = true) {
    new Load(true);

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: 'hover'
    }));

    const toastElList = document.querySelectorAll('.toast')
    const toastList = [...toastElList].map(toastEl => new bootstrap.Toast(toastEl))

    initializeDateTimePicker();
    initializeCountryRegionSelector();
    initializePaymentContainer();
    initializeSocialButtonShare();
    initializePagination();
    initializeTextEditor();
    initializePaymentForm();
    initializeCopyTicketInformation();
    initializeGalleryBlock(reset);
    initializePaymentTypeSelector();

    if (window.history.replaceState) {
        window.history.replaceState(null, null, window.location.href);
    }

    let template = new TemplateEngine();

    new Load(false);
}


// Fixing cart continue button on Mozilla Firefox
let mainDiv = $('main');
if ($(mainDiv).find('.cart-continue-btn').length > 0) {
    $(mainDiv).addClass('has-cart-continue-btn');
}

// Disable mouse wheel on input number
$(document).on('wheel', 'input[type="number"]', function () {
    $(this).blur();
})

/**
 * Submit form using form ajax
 */
$(document).on('submit', 'form', function (e) {
    e.preventDefault();
    formAjax($(this));
});

/**
 * Submit form using form ajax
 */
$('.btn-submit').on('click', function () {
    formAjax($(this).closest('form'));
});


$(document).on('change', '.cart-change-update', function () {
    formAjax($(this).closest('form'));
});

// Hide and show the participant auth block tabs
$('.view-login-form').on('click', function () {
    $('.login-form').removeClass('d-none');
    $('.register-form').addClass('d-none');
    $('.compact-form').addClass('d-none');
    $('.password-form').addClass('d-none');
});

$('.view-register-form').on('click', function () {
    $('.login-form').addClass('d-none');
    $('.register-form').removeClass('d-none');
    $('.compact-form').addClass('d-none');
    $('.password-form').addClass('d-none');
});

$('.view-password-form').on('click', function () {
    $('.login-form').addClass('d-none');
    $('.register-form').addClass('d-none');
    $('.compact-form').addClass('d-none');
    $('.password-form').removeClass('d-none');
});

// Deals with the section borders clipping the previous section
$('.section-border-pointed').prev('section').addClass('next-section-border-pointed');
$('.section-border-waves').prev('section').addClass('next-section-border-waves');

// Deals with the scrollable recent donations block
$('.slider-donations-controller').on('click', function () {
    let DonationsScroll = $(this).parent().find('> div');
    let DonationsScrollPosition = DonationsScroll.scrollLeft();
    if ($(this).is('[data-control="left"]')) {
        $(DonationsScroll).animate({
            scrollLeft: DonationsScrollPosition - 350
        })
    } else {
        $(DonationsScroll).animate({
            scrollLeft: DonationsScrollPosition + 350
        })
    }
});
